import { render } from "./LayoutFooter.vue?vue&type=template&id=8f774260"
import script from "./LayoutFooter.vue?vue&type=script&lang=js"
export * from "./LayoutFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__